<script lang="ts">
    import type Monster from "../../lib/monster";
    import type { Attributes } from "../../lib/types";
    import {
        getAttrPath,
        getAttrScalePath,
        getAttrIcon,
    } from "./util";

    export let dimensions: number;
    export let monster: Monster;

    const attributeKeys: (keyof Attributes)[] = [
        'health',
        'mana',
        'attack',
        'magic',
        'defense',
        'speed',
        'luck',
    ];
</script>

<svg height={dimensions} width={dimensions}>
    <path
        {...getAttrPath(monster, attributeKeys, dimensions)}
    />
    <path
        {...getAttrScalePath(monster, attributeKeys, dimensions)}
    />
    {#each attributeKeys as key, i (key)}
        <path {...getAttrIcon(monster, key, i, dimensions)}/>
    {/each}
</svg>

<style>

</style>
